// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"de915768","499":"6351a5df","959":"de915768"}[chunkId] + ".chunk.css";
};